import { RootState } from '../../rootReducer';
import { UserState } from './types';

export const selectCurrentUser = (state: RootState): UserState => {
  return state.user;
};
